<!--
 * @Author: yeqing
 * @Date: 2021-11-24 09:54:08
 * @LastEditTime: 2021-12-21 10:07:14
 * @LastEditors: wumao
 * @Description: 中小企业测评结果
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\smEvaluation\result.vue
-->
<template>
  <div class="container">
    <ResultCover ref="cover" :resultData="resultData" />
    <ResultCatalogue ref="cata" style="margin-top:20px" :resultData="resultData" />
    <ResultPageOne ref="page1" style="margin-top:20px" :resultData="resultData" />
    <ResultPageTwo ref="page2" style="margin-top:20px" :resultData="resultData" />
    <ResultPageThree ref="page3" style="margin-top:20px;" :resultData="resultData" />
    <cs-loading v-show="loading" text="报告生成中"></cs-loading>
    <van-button v-if="!loading" :loading="loading" color="#0072F7" class="download-btn" size="small" type="primary" loading-text="报告生成中" @click="onDownload"> 下载报告 </van-button>
  </div>
</template>

<script>
import ResultCover from './pdfComponents/resultCover.vue'
import ResultCatalogue from './pdfComponents/resultCatalogue.vue'
import ResultPageOne from './pdfComponents/resultPageOne.vue'
import ResultPageTwo from './pdfComponents/resultPageTwo.vue'
import ResultPageThree from './pdfComponents/resultPageThree.vue'
import CsLoading from '@/components/mask/index.vue'

import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas-dwei' // 为了兼容ios13 引入了别人的兼容版本，这又导致了不能识别base64，和背景图的问题。
import { pdfUploadApi, pdfDownloadApi } from '@/api/enterpriseSpecial'

const SCALE = 3 //缩放比例

export default {
  name: 'SmEvaluationResultH5',
  data() {
    return {
      imgs: [], //img dom元素集合
      resultData: {},
      pdfUrl: '',
      loading: false,
      downloadLoading: false,
      visible: false,
    }
  },
  components: {
    ResultCover,
    ResultCatalogue,
    ResultPageOne,
    ResultPageTwo,
    ResultPageThree,
    CsLoading,
  },
  created() {
    const resultData = JSON.parse(sessionStorage.getItem('resultData'))
    this.resultData = resultData
    document.title = '测评报告'
  },
  mounted() {
    this.loading = true
    if (this.isIOS()) {
      // ios13 必须要先滚动一段距离才能识别到最后一张pdf（这是为什么呀，一直不明白，垃圾ios），所以有了这段逻辑！
      document.body.scrollTop = 1000
      document.documentElement.scrollTop = 1000
      window.scrollTo(0, 1000)
    }

    setTimeout(() => {
      this.uploadPdf()
    }, 1000)
  },
  methods: {
    async onDownload() {
      if (!this.pdfUrl) return
      window.location.href = this.pdfUrl
    },
    async downloadPdf() {
      this.downloadLoading = true
      await pdfDownloadApi(this.resultData.recordId)
      this.downloadLoading = false
      this.doc && this.doc.save('专精特新中小企业测评报告.pdf')
    },
    async uploadPdf() {
      this.loading = true
      const file = await this.generatePdfFile()
      const formData = new FormData()
      formData.append('file', file)
      formData.append('recordId', this.resultData.recordId)
      const res = await pdfUploadApi(formData)
      this.loading = false
      if (this.isIOS()) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.scrollTo(0, 0)
        this.pdfUrl = res.data + '?response-content-type=application/octet-stream'
      } else {
        this.pdfUrl = res.data
      }
    },
    async generatePdfFile() {
      const imgs = await Promise.all([this.html2img(this.$refs.cover.$el), this.html2img(this.$refs.cata.$el), this.html2img(this.$refs.page1.$el), this.html2img(this.$refs.page2.$el), this.html2img(this.$refs.page3.$el)])
      this.imgs = imgs
      if (imgs.length) {
        this.doc = new jsPDF('p', 'px', [imgs[0].naturalWidth / SCALE, imgs[0].naturalHeight / SCALE])
        for (let i = 0; i < imgs.length; i++) {
          const img = imgs[i]
          this.doc.addImage(img, 0, 0, img.naturalWidth / SCALE, img.naturalHeight / SCALE)
          // 如果有下一张图片，就添加一张pdf页面
          if (i + 1 < imgs.length) {
            const nextImg = imgs[i + 1]
            this.doc.addPage([nextImg.naturalWidth / SCALE, nextImg.naturalHeight / SCALE])
          }
        }
        // doc.save('test.pdf')
        const arraybuffer = this.doc.output('arraybuffer')
        return this.arrayBuffer2file(arraybuffer, '专精特新中小企业测评报告')
      }
    },
    // html 转为 img 对象
    html2img(dom) {
      return new Promise((resolve, reject) => {
        html2canvas(dom, { scale: SCALE, useCORS: true })
          .then((canvas) => {
            let image = new Image()
            image.onload = () => {
              resolve(image)
            }
            image.onerror = (err) => {
              console.log('图片加载错误', err)
              reject(err)
            }
            image.crossOrigin = 'anonymous'
            const url = canvas.toDataURL('image/jpeg', 1)
            image.src = url
          })
          .catch((err) => {
            console.log('html2canvas', err)
          })
      })
    },
    arrayBuffer2file(arrayBuffer, name) {
      return new File([arrayBuffer], name)
    },
    isIOS() {
      let equipmentType = false
      let agent = navigator.userAgent.toLowerCase()
      let android = agent.indexOf('android')
      let iphone = agent.indexOf('iphone')
      let ipad = agent.indexOf('ipad')
      if (android != -1) {
        equipmentType = false
      }
      if (iphone != -1 || ipad != -1) {
        equipmentType = true
      }
      return equipmentType
    },
  },
}
</script>
<style lang="less" scoped>
html {
  font-size: 75px;
}
.container {
  height: 100%;
  padding: 0.3rem;
  overflow: auto;
  .download-btn {
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 10px;
    width: 2.24rem;
    height: 0.7rem;
    border-radius: 0.35rem;
    font-size: 0.24rem;
    z-index: 999;
  }
}
</style>
